<template>
  <main-container>
    <common-header/>
    <section-heading>ページ一覧</section-heading>
      <contents-container>
        <item-container>
          <form-input
              v-model="vtkt"
              placeholder="vtkt設定"
              name="textfield-component"
              type="text"
          ></form-input>
          <button-main @click="copyCookie()">cookiesにvtktを設定する</button-main>
        </item-container>
        <item-container>
          <form-input
              v-model="pageId"
              placeholder="ページID"
              name="textfield-component"
              type="text"
          ></form-input>
          <button-main @click.prevent="goToPage()">ページIDに遷移する</button-main>
        </item-container>
        <item-container>
          <heading-label>Phase1.5画面</heading-label>
        </item-container>
        <item-container>
          <contents-text><router-link :to="{ name:'rep300'}">rep300 事前申請</router-link></contents-text>
        </item-container>
        <item-container>
          <contents-text><router-link :to="{ name:'rep050'}">rep050 申請完了画面</router-link></contents-text>
        </item-container>
        <item-container>
          <contents-text><router-link :to="{ name:'rep050'}">rep050 エラー(動的)</router-link></contents-text>
        </item-container>
        <item-container>
          <contents-text><router-link :to="{ name:'rep082'}">rep082 404エラー(静的)</router-link></contents-text>
        </item-container>
        <item-container>
          <contents-text><router-link :to="{ name:'rep085'}">rep085 500エラー(静的)</router-link></contents-text>
        </item-container>
      </contents-container>
    <common-footer/>
  </main-container>
</template>

<script>
import CommonHeader from '../components/common/CommonHeader'
import CommonFooter from '../components/common/CommonFooter'
import MainContainer from '../components/container/MainContainer'
import ContentsContainer from '../components/container/ContentsContainer'
import ItemContainer from '../components/container/ItemContainer'
import SectionHeading from '../components/heading/SectionHeading'
import ContentsText from '../components/text/ContentsText'
import FormInput from '../components/form/FormInput'
import ButtonMain from '../components/button/ButtonMain'
import HeadingLabel from "../components/heading/HeadingLabel";

export default {
  name: "pagelist",
  components: {
      HeadingLabel,
    CommonHeader,
    CommonFooter,
    MainContainer,
    ContentsContainer,
    ItemContainer,
    SectionHeading,
    ContentsText,
    FormInput,
    ButtonMain,
  },
  data() {
    return {
      pageId: '',
      vtkt: ''
    }
  },
  methods: {
    goToPage () {
      console.log('this.pageId', this.pageId)
      if (this.pageId) {
        let pageName = this.pageId.toLowerCase()
        let routeData = this.$router.resolve({name: pageName})
        window.open(routeData.href, '_blank')
      }
    },
    copyCookie () {
      document.cookie = 'VTKT=' + this.vtkt + '; path=/'
    }
  }
}
</script>
